import React from 'react';
import '../../App.css';
import './TermsOfSalePage.css';

function TermsOfSalePage() {
  return (
    <div className="page info-page terms-of-sale-page">
      <div className="info-columns">
        <div className="info-column">
          <h2>Terms of Sale</h2>

          
          <h3>General</h3>
          <p>These terms apply to purchases on ideafarm.se.</p>

          <h3>Prices & payment</h3>
          <ul>
            <li>All prices are listed in SEK including VAT.</li>
            <li>Payment is processed via our payment partners (e.g. Stripe).</li>
          </ul>

          <h3>Delivery</h3>
          <ul>
            <li>Physical products are shipped within 2 business days.</li>
            <li>Digital products are delivered via email/download link immediately after payment.</li>
          </ul>

          <h3>Right of withdrawal</h3>
          <ul>
            <li>As a consumer you have a 14-day right of withdrawal under EU law (Consumer Rights Directive).</li>
            <li>To return a product, contact us at <a href="mailto:admin@ideafarm.se">admin@ideafarm.se</a>.</li>
            <li>Return shipping is paid by the customer unless the item is defective.</li>
          </ul>

          <h3>Complaints</h3>
          <p>In the event of defects, current consumer legislation applies.</p>

          <h3>Contact information</h3>
          <p>Idea Farm<br />
          Org.nr 559321-1039<br />
          [Address]<br />
          Email: <a href="mailto:admin@ideafarm.se">admin@ideafarm.se</a></p>
        </div>
        <div className="info-column">
          <h2>Köpvillkor</h2>

          <h3>Allmänt</h3>
          <p>Dessa villkor gäller vid köp på ideafarm.se.</p>

          <h3>Priser & betalning</h3>
          <ul>
            <li>Alla priser anges i SEK inklusive moms.</li>
            <li>Betalning sker via våra betalningspartners (t.ex. Stripe).</li>
          </ul>

          <h3>Leverans</h3>
          <ul>
            <li>Varor skickas inom 2 arbetsdagar.</li>
            <li>Digitala produkter levereras via e-post/länk direkt efter betalning.</li>
          </ul>

          <h3>Ångerrätt</h3>
          <ul>
            <li>Som konsument har du 14 dagars ångerrätt enligt Distansavtalslagen.</li>
            <li>Vid retur kontaktar du oss på <a href="mailto:admin@ideafarm.se">admin@ideafarm.se</a>.</li>
            <li>Returfrakt bekostas av kunden, om inte varan är felaktig.</li>
          </ul>

          <h3>Reklamationer</h3>
          <p>Vid fel på vara tillämpas gällande konsumentlagstiftning.</p>

          <h3>Kontaktuppgifter</h3>
          <p>Idea Farm AB<br />
          Org.nr 559321-1039<br />
          [Adress]<br />
          E-post: <a href="mailto:admin@ideafarm.se">admin@ideafarm.se</a></p>
        </div>
      </div>
    </div>
  );
}

export default TermsOfSalePage;
